interface ITimelineService {
  getDefaultStartDate(): Date;
  getDefaultEndDate(): Date;
  addDays(date: Date, days: number): Date;
  addHours(date: Date, hours: number): Date;
}

class TimelineService implements ITimelineService {
  getDefaultStartDate(): Date {
    const defaultDate = new Date();
    defaultDate.setHours(0, 0, 0, 0);
    defaultDate.setDate(defaultDate.getDate() - 45);
    return defaultDate;
  }

  getDefaultEndDate(): Date {
    const defaultDate = new Date();
    defaultDate.setHours(0, 0, 0, 0);
    defaultDate.setDate(defaultDate.getDate());
    return defaultDate;
  }

  addDays(date: Date, days: number): Date {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  addHours(date: Date, hours: number): Date {
    date.setTime(date.getTime() + hours * 60 * 60 * 1000);
    return date;
  }
}

export const timelineService: ITimelineService = new TimelineService();
